import { useEffect } from "react";
import { isNativeApp } from "@/lib/native";
import { registerPush } from "@/lib/push";

// Registers this phone for trade-signal push notifications (native apps only).
export default function PushRegistrar() {
  useEffect(() => {
    if (isNativeApp()) registerPush();
  }, []);
  return null;
}
